import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Segment,
  Icon,
  FormGroup,
  FormField,
  Input,
  Radio,
  Button
} from 'semantic-ui-react'

const ModOpenEmergencyUX = (props: any) => {
    return(
      <div
        id="ModOpenEmergencyUX-div-0"
        style={{ width : "100%", height: "100%" }}>
        <Segment
          id="ModOpenEmergencyUX-Segment-1">
          <div
            id="ModOpenEmergencyUX-div-2"
            style={{display: "flex", justifyContent: "space-between"}}>
            
            <div
              id="ModOpenEmergencyUX-div-3"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Emergency registration" : "ลงทะเบียนฉุกเฉิน"}
            </div>
            <div
              id="ModOpenEmergencyUX-div-12"
              style={{cursor: "pointer"}}>
              
              <Icon
                className="red"
                id="ModOpenEmergencyUX-Icon-14"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
          <hr
            id="ModOpenEmergencyUX-hr-6">
          </hr>
          <div
            className="ui form"
            id="ModOpenEmergencyUX-div-7">
            
            <div
              id="ModOpenEmergencyUX-div-15"
              style={{width: "100%"}}>
              {props.ErrorMessage}
            </div>
            <FormGroup
              id="ModOpenEmergencyUX-FormGroup-16"
              inline={true}>
              <FormField
                id="ModOpenEmergencyUX-FormField-17"
                inline={true}
                width={2}>
                <label
                  id="ModOpenEmergencyUX-label-18"
                  style={{textAlign: "left", width: "100%"}}>
                  HN : 
                </label>
              </FormField>
              <FormField
                id="ModOpenEmergencyUX-FormField-19"
                inline={true}
                width={5}>
                <Input
                  disabled={true}
                  id="ModOpenEmergencyUX-Input-20"
                  readOnly={true}
                  style={{width:"100%"}}
                  value={props.hn}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModOpenEmergencyUX-FormGroup-21"
              inline={true}>
              <FormField
                className="required"
                id="ModOpenEmergencyUX-FormField-22"
                inline={true}
                width={2}>
                <label
                  id="ModOpenEmergencyUX-label-23"
                  style={{textAlign: "left", width: "100%"}}>
                  {props.languageUX === "en" ? "sex" : "เพศ"}
                </label>
              </FormField>
              <FormField
                id="ModOpenEmergencyUX-FormField-24"
                inline={true}
                width={10}>
                <Radio
                  checked={props.gender  === "M"}
                  id="ModOpenEmergencyUX-Radio-25"
                  label={props.languageUX === "en" ? "man" : "ชาย"}
                  name="gender"
                  onChange={props.changeValue("gender")}
                  style={{ marginRight: "20px" }}
                  value="M">
                </Radio>
                <Radio
                  checked={props.gender  === "F"}
                  id="ModOpenEmergencyUX-Radio-26"
                  label={props.languageUX === "en" ? "female" : "หญิง"}
                  name="gender"
                  onChange={props.changeValue("gender")}
                  style={{ marginRight: "20px" }}
                  value="F">
                </Radio>
                <Radio
                  checked={props.gender  === "CM"}
                  id="ModOpenEmergencyUX-Radio-27"
                  label={props.languageUX === "en" ? "boy" : "เด็กชาย"}
                  name="gender"
                  onChange={props.changeValue("gender")}
                  style={{ marginRight: "20px" }}
                  value="CM">
                </Radio>
                <Radio
                  checked={props.gender  === "CF"}
                  id="ModOpenEmergencyUX-Radio-28"
                  label={props.languageUX === "en" ? "girl" : "เด็กหญิง"}
                  name="gender"
                  onChange={props.changeValue("gender")}
                  style={{ marginRight: "20px" }}
                  value="CF">
                </Radio>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModOpenEmergencyUX-FormGroup-29"
              inline={true}>
              <FormField
                id="ModOpenEmergencyUX-FormField-30"
                inline={true}
                width={2}>
                <label
                  id="ModOpenEmergencyUX-label-31"
                  style={{textAlign: "left", width: "100%"}}>
                  {props.languageUX === "en" ? "name :" : "ชื่อ :"}
                </label>
              </FormField>
              <FormField
                id="ModOpenEmergencyUX-FormField-32"
                inline={true}
                width={5}>
                <Input
                  id="ModOpenEmergencyUX-Input-33"
                  onChange={props.changeValue("first_name")}
                  style={{width:"100%"}}
                  value={props.first_name}>
                </Input>
              </FormField>
              <FormField
                id="ModOpenEmergencyUX-FormField-34"
                inline={true}
                width={2}>
                <label
                  id="ModOpenEmergencyUX-label-35"
                  style={{textAlign: "left", width: "100%"}}>
                  {props.languageUX === "en" ? "surname :" : "นามสกุล :"}
                </label>
              </FormField>
              <FormField
                id="ModOpenEmergencyUX-FormField-36"
                inline={true}
                width={5}>
                <Input
                  id="ModOpenEmergencyUX-Input-37"
                  onChange={props.changeValue("last_name")}
                  style={{width:"100%"}}
                  value={props.last_name}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModOpenEmergencyUX-FormGroup-38"
              inline={true}>
              <FormField
                id="ModOpenEmergencyUX-FormField-39"
                inline={true}
                width={3}>
                <Button
                  color="green"
                  id="ModOpenEmergencyUX-Button-43"
                  onClick={props.OnSave}
                  style={{width:"100%"}}>
                  {props.languageUX === "en" ? "Save" : "บันทึก"}
                </Button>
              </FormField>
              <FormField
                id="ModOpenEmergencyUX-FormField-41"
                inline={true}
                width={3}>
                <Button
                  color="teal"
                  id="ModOpenEmergencyUX-Button-42"
                  onClick={props.OnClear}
                  style={{width:"100%"}}>
                  {props.languageUX === "en" ? "Clear" : "ล้างหน้าจอ"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
        </Segment>
      </div>
    )
}


export default ModOpenEmergencyUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Wed Oct 01 2025 12:49:42 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Segment",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Segment-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ลงทะเบียนฉุกเฉิน",
          "valueEN": "Emergency registration"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-hr-6"
        }
      },
      "seq": 6,
      "void": true
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-div-7"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Icon",
      "parent": 12,
      "props": {
        "className": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Icon-14"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormGroup-16"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "HN : "
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"left\", width: \"100%\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Input",
      "parent": 19,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Input-20"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.hn"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormGroup-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 21,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "เพศ",
          "valueEN": "sex"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"left\", width: \"100%\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "Radio",
      "parent": 24,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.gender  === \"M\""
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Radio-25"
        },
        "label": {
          "type": "value",
          "value": "ชาย",
          "valueEN": "man"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeValue(\"gender\")"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "value": {
          "type": "value",
          "value": "M"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Radio",
      "parent": 24,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.gender  === \"F\""
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Radio-26"
        },
        "label": {
          "type": "value",
          "value": "หญิง",
          "valueEN": "female"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeValue(\"gender\")"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "value": {
          "type": "value",
          "value": "F"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Radio",
      "parent": 24,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.gender  === \"CM\""
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Radio-27"
        },
        "label": {
          "type": "value",
          "value": "เด็กชาย",
          "valueEN": "boy"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeValue(\"gender\")"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "value": {
          "type": "value",
          "value": "CM"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Radio",
      "parent": 24,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.gender  === \"CF\""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Radio-28"
        },
        "label": {
          "type": "value",
          "value": "เด็กหญิง",
          "valueEN": "girl"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeValue(\"gender\")"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\" }"
        },
        "value": {
          "type": "value",
          "value": "CF"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormGroup-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ :",
          "valueEN": "name :"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-label-31"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"left\", width: \"100%\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Input",
      "parent": 32,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Input-33"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeValue(\"first_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.first_name"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "นามสกุล :",
          "valueEN": "surname :"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-label-35"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"left\", width: \"100%\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Input",
      "parent": 36,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Input-37"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeValue(\"last_name\")"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.last_name"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormGroup",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormGroup-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Button",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้างหน้าจอ",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Button-42"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnClear"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "ModOpenEmergencyUX-Button-43"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnSave"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        }
      },
      "seq": 43,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": false,
  "memo": false,
  "name": "ModOpenEmergencyUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 60
}

*********************************************************************************** */
